import { Component, OnInit, Input } from '@angular/core';
import { ViewWorkDataQuestion } from 'src/app/Elearning-Models';
import { Subscription } from 'rxjs';
import { FilterQuestionsService } from 'src/app/Services/filter-questions.service';

@Component({
  selector: 'app-fact',
  templateUrl: './fact.component.html',
  styleUrls: ['./fact.component.scss']
})
export class FactComponent implements OnInit {
@Input() question: ViewWorkDataQuestion;
@Input() isConsumerCurriculum: boolean;

filterSubscription: Subscription;
filterValue: string;

  constructor(
    private filterQuestionService: FilterQuestionsService
  ) { }

  ngOnInit(): void {
    this.filterSubscription = this.filterQuestionService.currentFilterValue.subscribe(
      (filterValue) => {
        this.filterValue = filterValue;
      }
    );
  }

}
